import Search from "../components/Search/Search";
import Map from "../components/Map/Map";
import Filter from "../components/Filter/Filter";
import { useEffect, useState, useMemo } from "react";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";

const Layout = () => {
  const [openFilter, setOpenFilter] = useState(false);
  const initialCenter = {
    lat: 0,
    lng: 0,
    current_latitude: 0,
    current_longitude: 0,
  };
  const [center, setCenter] = useState(initialCenter);
  const [loading, setLoading] = useState(false);

  const initialApiRequest = {
    data: ["ACTIVITIES", "EVENTS", "PLACES"],
    searchtext: "",
    sports: [],
    latitude: center.lat,
    longitude: center.lng,
    distance: 15,
    current_latitude: center.current_latitude,
    current_longitude: center.current_longitude,
  };
  const [apiRequest, setApiRequest] = useState(initialApiRequest);
  const initialLocations = {
    activities: [],
    events: [],
    places: [],
  };
  const [locations, setLocations] = useState(initialLocations);

  // useEffect(() => {
  //   if(center.lat === apiRequest.latitude && center.lng === apiRequest.latitude && userCoordinates.lat === apiRequest.current_latitude && userCoordinates.lng === apiRequest.current_longitude) {
  //     return
  //   }
  //   setApiRequest((prev) => ({
  //     ...prev,
  //     latitude: center.lat,
  //     longitude: center.lng,
  //     current_latitude: userCoordinates.lat,
  //     current_longitude: userCoordinates.lng
  //   }))
  // }, [center, userCoordinates]);

  const cssOverride = {
    position: "absolute",
    top: "calc(50% - 32px)",
    left: "calc(50% - 32px)",
    transform: "translate(-50%, -50%)",
  };

  const memoizedRequest = useMemo(
    () => apiRequest,
    [
      apiRequest.latitude,
      apiRequest.longitude,
      apiRequest.searchtext,
      apiRequest.data,
      apiRequest.sports,
    ]
  );

  useEffect(() => {
    if (memoizedRequest.latitude === 0 && memoizedRequest.longitude === 0) {
      return;
    }
    setLoading(true);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}discover`, memoizedRequest)
      .then((res) => {
        if (
          !res.data.data.places.length &&
          !res.data.data.events.length &&
          !res.data.data.activities.length
        ) {
          toast.error("No activities , events & places available", {
            duration: 1000,
          });
        }
        setLocations(res.data.data);
        // setOpenFilter(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err.message);
      });
  }, [memoizedRequest]);

  return (
    <>
      <Search
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        setApiRequest={setApiRequest}
      />
      <Map
        locations={locations}
        center={center}
        setCenter={setCenter}
        setApiRequest={setApiRequest}
      />
      <Filter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        setApiRequest={setApiRequest}
        loading={loading}
      />
      <Toaster />
      <ClipLoader size={50} loading={loading} cssOverride={cssOverride} />
    </>
  );
};

export default Layout;
